import FormInput from '../../../../components/atoms/Input/Form-Input'
import { CACTUS_FILTER_OPTIONS, SHIPPING_DESTINATION_OPTIONS } from '../constants'

const OrderFilters = ({
    isCactusAdmin,
    isSaddlefitAdmin,
    statusFilter,
    shippingFilter,
    statusOptions,
    onStatusFilterChange,
    onShippingFilterChange,
}) => {
    return (
        <div className="filters-section no-print">
            <h3 className="filters-title">Filter Orders</h3>
            <div className="filters-grid">
                <FormInput
                    name="status-filter"
                    type="select2"
                    label="By Status"
                    height={48}
                    placeholder="All Statuses"
                    options={isCactusAdmin ? CACTUS_FILTER_OPTIONS : statusOptions}
                    selectedValues={statusFilter}
                    onChange={onStatusFilterChange}
                    isClearable
                    className="w-full"
                />
                {isSaddlefitAdmin && (
                    <FormInput
                        name="shipping-filter"
                        type="select2"
                        label="By Shipping Destination"
                        height={48}
                        placeholder="All Destinations"
                        options={SHIPPING_DESTINATION_OPTIONS}
                        selectedValues={shippingFilter}
                        onChange={onShippingFilterChange}
                        isClearable
                        className="w-full"
                    />
                )}
            </div>
        </div>
    )
}

export default OrderFilters
